/**
 * Datatype of the entitlement attribute.
 * - Tag: 1779
 * - FIX Specification type: int
 * - Mapped type: number
 * @readonly
 * @public
 */
export const EntitlementAttribDatatype = Object.freeze({
    /** int */
    Int: 1,
    /** Length */
    Length: 2,
    /** NumInGroup */
    NumInGroup: 3,
    /** SeqNum */
    SeqNum: 4,
    /** TagNum */
    TagNum: 5,
    /** float */
    Float: 6,
    /** Qty */
    Qty: 7,
    /** Price */
    Price: 8,
    /** PriceOffset */
    PriceOffset: 9,
    /** Amt */
    Amt: 10,
    /** Percentage */
    Percentage: 11,
    /** char */
    Char: 12,
    /** Boolean */
    Boolean: 13,
    /** String */
    String: 14,
    /** MultipleCharValue */
    MultipleCharValue: 15,
    /** Currency */
    Currency: 16,
    /** Exchange */
    Exchange: 17,
    /** MonthYear */
    MonthYear: 18,
    /** UTCTimestamp */
    UTCTimestamp: 19,
    /** UTCTimeOnly */
    UTCTimeOnly: 20,
    /** LocalMktDate */
    LocalMktDate: 21,
    /** UTCDateOnly */
    UTCDateOnly: 22,
    /** data */
    Data: 23,
    /** MultipleStringValue */
    MultipleStringValue: 24,
    /** Country */
    Country: 25,
    /** Language */
    Language: 26,
    /** TZTimeOnly */
    TZTimeOnly: 27,
    /** TZTimestamp */
    TZTimestamp: 28,
    /** Tenor */
    Tenor: 29,
    /** DayOfMonth */
    DayOfMonth: 30,
    /** XMLData */
    XMLData: 31,
    /** Pattern */
    Pattern: 32,
    /** Reserved100Plus */
    Reserved100Plus: 33,
    /** Reserved1000Plus */
    Reserved1000Plus: 34,
    /** Reserved4000Plus */
    Reserved4000Plus: 35,
} as const);

export type EntitlementAttribDatatype = (typeof EntitlementAttribDatatype)[keyof typeof EntitlementAttribDatatype];
